import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],

      addItem: (item) => {
        const existingItem = get().items.find((i) => i.objectID === item.objectID);
        if (existingItem) {
          set({
            items: get().items.map((i) =>
              i.objectID === item.objectID ? { ...i, quantity: i.quantity + 0 } : i
            ),
          });
        } else {
          set({ items: [...get().items, { ...item, quantity: 1 }] });
        }
      },

      removeItem: (itemId) => {
        set({ items: get().items.filter((item) => item.objectID !== itemId) });
      },

      updateQuantity: (itemId, quantity) => {
        if (quantity <= 0) {
          get().removeItem(itemId);
        } else {
          set({
            items: get().items.map((item) =>
              item.objectID === itemId ? { ...item, quantity } : item
            ),
          });
        }
      },

      clearCart: () => set({ items: [] }),
    }),
    {
      name: "cart-storage", // Key for localStorage
      getStorage: () => localStorage,
    }
  )
);
